import AppRestService from './app-rest.service';
import NewsModel from '../models/news.model';



/**
 * Service Endpoint Implementation
 */
export default class NewsService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'news';
    this.routePath = 'news';
    this.idParamName = 'news_id';
    this.modelClass = NewsModel;
    this.authEnabled = true;
  }

}

